export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_5.ca1d328e.jpg";